<template>
  <div>
    <c-modal
        v-if="isOpen"
        size="md"
        :title="title"
        @close="$emit('close')"
    >
      <div class="modal-body">
        <p class="confirm-delete-message">
          <strong v-html="description"></strong>
        </p>
        <div class="well confirm-delete-label" v-if="body">{{ body }}</div>
      </div>

      <div class="modal-footer">
        <div class="c-confirm-delete-modal-footer">
          <c-button
              type="button"
              theme="default"
              class="pull-left"
              icon="fa-xmark"
              @click="$emit('close')"
          >
            Cancel
          </c-button>

          <c-button
              type="button"
              :theme="deleteBtnTheme"
              :icon="deleteBtnIcon"
              :showIndicator="showIndicator"
              @click="$emit('confirm')"
          >
            {{ deleteBtnName }}
          </c-button>
        </div>

      </div>
    </c-modal>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    showIndicator: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    body: {
      type: String,
      default: ''
    },
    deleteBtnName: {
      type: String,
      default: 'Delete'
    },
    deleteBtnIcon: {
      type: String,
      default: 'fa-trash-can'
    },
    deleteBtnTheme: {
      type: String,
      default: 'danger'
    }
  },
  emits: ['close', 'confirm']
}
</script>

<style scoped>
.modal {
  z-index: 1055;
}

.c-confirm-delete-modal-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

</style>